"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onApiError;

function onApiError(e) {
  if (!e.status) {
    return;
  }

  switch (e.status) {
    case 401:
      break;
  }
}